import * as _ from 'lodash';
import { GridCell } from '@progress/kendo-react-grid';
import * as React from 'react';
import { SplitButton, MenuItem, Button, ButtonToolbar } from 'react-bootstrap';

import { Formatters } from '../..//formatters';
import { GridUtilities } from '../gridutilities';

export const OutstandingBidActionKeys = {
    viewDetails: 'viewDetails',
    setLostStatus: 'setLostStatus',
    editOrder: 'editOrder',
    followUp: 'followUp',
};

export class GridCellDropdownActionsOutstandingBids extends GridCell {
    public constructor(props: any) {
        super(props);
    }

    public handleButton(e: any, o: any) {
        const { dataItem, field, onChange } = this.props;

        const value = !Formatters.getBool(dataItem, field as string, false);

        if (onChange) {
            onChange({
                dataItem: dataItem,
                field: field,
                syntheticEvent: e.syntheticEvent,
                value: value
            });
        }
    }

    public render() {
        const { dataItem, field, ...rest } = this.props;

        const obj = dataItem[field as string];
        const buttonText = Formatters.getStr(obj, 'text');
        const buttonHref = Formatters.getStr(obj, 'href');
        const buttonTitle = Formatters.getStr(obj, 'title');
        const buttonOrderId = Formatters.getInt(obj, 'orderId');
        const buttonClickHandler = (e: any, k: any, o: any) => { obj.clickHandler(e, k, o); };

        const className = `k-grid-column-row-dropdown-actions`;

        let buttonProps = {
            bsStyle: 'success',
            bsSize: 'xs',
            disabled: false,
            title: buttonText,
        };

        const splitId = `ob-sb-${buttonOrderId}`;

        let menuItems = [
            {
                eventKey: OutstandingBidActionKeys.followUp,
                text: 'Follow Up'
            },
            {
                eventKey: OutstandingBidActionKeys.editOrder,
                text: 'Edit Bid'
            },
            // {
            //     eventKey: OutstandingBidActionKeys.setLostStatus,
            //     text: 'Set Lost Status'
            // },
        ];

        const cellInner = (
            <ButtonToolbar>
                <SplitButton {...buttonProps} id={splitId} onClick={(e) => { buttonClickHandler(e, OutstandingBidActionKeys.viewDetails, buttonOrderId); }}>
                    {_.map(menuItems, (o, i) => (<MenuItem key={`obdda-split-${i}`} eventKey={o.eventKey} onSelect={(k, e) => { buttonClickHandler(e, k, buttonOrderId); }}>{o.text}</MenuItem>))}
                </SplitButton>
            </ButtonToolbar>
        );

        return (<td className={className}>{cellInner}</td>);
    }
}

export class CellWithButtonFollowUp extends GridCell {
    public constructor(props: any) {
        super(props);
    }

    public handleButton(e: any, o: any) {
        const { dataItem, field, onChange } = this.props;

        const value = !Formatters.getBool(dataItem, field as string, false);

        if (onChange) {
            onChange({
                dataItem: dataItem,
                field: field,
                syntheticEvent: e.syntheticEvent,
                value: value
            });
        }
    }

    public render() {
        const { dataItem, field, ...rest } = this.props;

        const obj = dataItem[field as string];
        const buttonText = Formatters.getStr(obj, 'text');
        const buttonHref = Formatters.getStr(obj, 'href');
        const buttonTitle = Formatters.getStr(obj, 'title');
        const buttonOrderId = Formatters.getInt(obj, 'orderId');
        const buttonAssociationId = Formatters.getInt(obj, 'associationId');

        const buttonClickHandler = (e: any, o: any, a: any) => { obj.clickHandler(e, o, a); };

        const className = `k-grid-column-row-button-follow-up ${GridUtilities.KendoGridClassTextLeft}`;

        let buttonProps = {
            bsStyle: 'success',
            bsSize: 'xs',
            disabled: false,
            title: buttonText,
        };

        const cellInner = (
            <Button
                {...buttonProps}
                onClick={e => { buttonClickHandler(e, buttonOrderId, buttonAssociationId); }}
            >
                <i className="fa fa-calendar" /> {Formatters.getStr(buttonProps, 'title')}
            </Button>
        );

        return (<td className={className}>{cellInner}</td>);
    }
}



// WEBPACK FOOTER //
// ./src/common/grid/grid-cell-components/gridcell-dropdown-actions-bids-outstanding.tsx